export const SUPPORTED_LANGUAGE_CODES = [
  "en",
  "ko",
  "ja",
  "ar",
  "da",
  "de",
  "el",
  "es-ES",
  "es-MX",
  "fa",
  "fi",
  "fr",
  "he",
  "hi",
  "id",
  "it",
  "ms",
  "nb",
  "nl",
  "pl",
  "pt-BR",
  "pt-PT",
  "ru",
  "sv",
  "th",
  "tr",
  "uk",
  "vi",
  "zh-CN",
  "zh-TW",
] as const;

const SUPPORTED_LANGUAGE_SET = new Set<string>(SUPPORTED_LANGUAGE_CODES);

const LEGACY_LANGUAGE_CODES: Record<string, string> = {
  "ar-SA": "ar",
  "ar-XA": "ar",
  "da-DK": "da",
  "de-DE": "de",
  "el-GR": "el",
  "en-US": "en",
  "fa-IR": "fa",
  "fi-FI": "fi",
  "fr-FR": "fr",
  "he-IL": "he",
  "hi-IN": "hi",
  "id-ID": "id",
  "it-IT": "it",
  "ja-jp": "ja",
  "ko-kr": "ko",
  "ms-MY": "ms",
  "nb-NO": "nb",
  "nl-NL": "nl",
  "pl-PL": "pl",
  "ru-RU": "ru",
  "sv-SE": "sv",
  "th-TH": "th",
  "tr-TR": "tr",
  "uk-UA": "uk",
  "vi-VN": "vi",
};

export const normalizeLanguageCode = (languageCode?: string | null): string => {
  if (!languageCode) {
    return "en";
  }

  return LEGACY_LANGUAGE_CODES[languageCode] ?? languageCode;
};

export const isSupportedLanguage = (languageCode?: string): boolean =>
  Boolean(languageCode && SUPPORTED_LANGUAGE_SET.has(languageCode));
